import { Component } from '@angular/core';

@Component({
  templateUrl: './privacy.component.html',
})
export class PrivacyComponent {

}



// WEBPACK FOOTER //
// ./src/app/marketing/privacy.component.ts